<ng-container *ngIf="noTemplates">
    <div class="empty-page">
        <mat-icon>warning</mat-icon>
        <h2>{{ 'template.list.none_configured' | translate }}</h2>
    </div>
</ng-container>

<ng-container *ngIf="loading">
    <div class="empty-page">
        <mat-spinner diameter="60"></mat-spinner>
        <h2>{{ 'template.loading' | translate }}...</h2>
    </div>
</ng-container>
